module.exports = __webpack_public_path__ + "static/media/ArchaeologicalSite-Selected.dc3870a2.svg";